Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "CurrenciesDropdown376104280",
  {"currenciesDropdown":"CurrenciesDropdown376104280--currenciesDropdown","root":"CurrenciesDropdown376104280--root","backgroundColor":"'\"fallback(color(--currencyConverter_backgroundColor), color(color-1))\"'","borderColor":"'\"opacity(color(fallback(--currencyConverter_borderColor, color-5)), 0.6)\"'","borderColorOnHover":"'\"color(fallback(--currencyConverter_borderColor, color-5))\"'","font":"'\"fallback(font(--currencyConverter_textFont), font({theme: 'Body-M', size: '16px'}))\"'","textColor":"'\"fallback(color(--currencyConverter_textColor), color(color-5))\"'","selectedBGColorOnHover":"'\"opacity(color(fallback(--currencyConverter_textColor, color-5)), 0.06)\"'","disabledColor":"'\"color(color-3)\"'","borderWidth":"'\"fallback(unit(--currencyConverter_borderWidth, px), 1px)\"'"},
  "",
  10,
  "CurrenciesDropdown376104280"
);

